// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"UR-z","inlineTitle":"VR-z","sponsoredAdsWrapper":"WR-z","marketplaceRecosWrapper":"XR-z"};